import { useState, useEffect, useRef, } from "react";
import { useContext, useMemo } from "react";
import LevelTransmitterIndicator from "../components/LevelTransmitterIndicator";
import Transmitter from "../components/Transmitter";
import ControlValveControlPanel from "../components/ControlValveControlPanel";
import Valve from "../components/Valve";
import "./Desalter1.css";
import { WellContext } from "../context/WellContext";
import { AlarmContext } from "../context/AlarmContext";
import { PumpContext } from "../context/PumpContext";
import Pump from "../components/Pump";
import PumpFaceplate from "../components/PumpFaceplate";
import MDSFaceplate from "../components/MDSFaceplate";
import { PlantStore } from "../engine/PlantStore";
import { usePlantStore } from "../engine/usePlantStore";

import { trackPageVisit } from "../competency/PageTracker";
import Analyzer1Faceplate from "../components/Analyzer1Faceplate";
import AnalyzerV201AFaceplate from "../components/AnalyzerV201AFaceplate";

import ElectricGrid from "../components/ElectricGrid";
import ElectricGridButton from "../components/ElectricGridButton";
import TransmitterFaceplate from "../components/TransmitterFaceplate";





function ValveOutput({
    tag,
    value,
    x,
    y,
    r = 0,
    description = "Control Valve Opening"
}) {

    const [hover, setHover] = useState(false);
    const [showFaceplate, setShowFaceplate] = useState(false);

    return (
        <>
            {/* Hover */}
            {hover && (
                <div
                    style={{
                        position: "absolute",
                        left: x + 30,
                        top: y - 5,
                        background: "rgba(0,80,180,.85)",
                        color: "#fff",
                        padding: "5px 8px",
                        borderRadius: "4px",
                        border: "1px solid #4fc3ff",
                        fontSize: "11px",
                        zIndex: 9999,
                        pointerEvents: "none",
                        whiteSpace: "nowrap"
                    }}
                >
                    <strong>{tag}</strong><br />
                    {description}
                </div>
            )}

            {/* Original Valve Output */}
            <div
                onMouseEnter={() => setHover(true)}
                onMouseLeave={() => setHover(false)}
                onClick={() => setShowFaceplate(true)}
                style={{
                    position: "absolute",
                    left: x,
                    top: y,

                    color: "lime",
                    background: "black",

                    fontSize: "10px",
                    padding: "1px 4px",

                    borderRadius: "4px",
                    border: "1px solid #555",

                    transform: `rotate(${r}deg)`,
                    transformOrigin: "center",

                    cursor: "pointer",

                    fontWeight: "bold",

                    minWidth: "22px",
                    textAlign: "center",

                    transition: "0.2s",
                    boxShadow: hover
                        ? "0 0 8px rgba(0,255,255,.7)"
                        : "none"
                }}
            >
                {Number(value).toFixed(1)} %
            </div>

            {showFaceplate && (
                <TransmitterFaceplate
                    tag={tag}
                    value={Number(value)}
                    unit="%"
                    min={0}
                    max={100}
                    HH={100}
                    H={90}
                    L={10}
                    LL={0}
                    description={description}
                    x={x + 35}
                    y={y + 20}
                    onClose={() => setShowFaceplate(false)}
                />
            )}
        </>
    );
}




function Desalter1() {

    useEffect(() => {
    
      trackPageVisit("Desalter1");
    
    }, []);
  
     const { toggleValve, valves} = useContext(WellContext);

const [hoveredValve, setHoveredValve] = useState(null);
const [showMDS, setShowMDS] = useState(false);
const [showAnalyzerV201A, setShowAnalyzerV201A] =  useState(false);

     

  const DEFAULT_VALVES = {
  PDV_12001: { mode: "Manual", opening: 0, sp: "", pv: "" },
  LCV_12001: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_12001: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_12002: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_12003: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_12004: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_12005: { mode: "Manual", opening: 0, sp: "", pv: "" },
  FCV_12006: { mode: "Manual", opening: 0, sp: "", pv: "" },

};

const [valveData, setValveData] = useState(() => {
  const saved = localStorage.getItem("Desalter1_valveData");

  if (!saved) return DEFAULT_VALVES;

  try {
    const parsed = JSON.parse(saved);

    // ✅ Merge saved + default (CRITICAL)
    return {
      PDV_12001: { ...DEFAULT_VALVES.PDV_12001, ...parsed.PDV_12001 },
      LCV_12001: { ...DEFAULT_VALVES.LCV_12001, ...parsed.LCV_12001 },
      FCV_12001: { ...DEFAULT_VALVES.FCV_12001, ...parsed.FCV_12001 },
      FCV_12002: { ...DEFAULT_VALVES.FCV_12002, ...parsed.FCV_12002 },
      FCV_12003: { ...DEFAULT_VALVES.FCV_12003, ...parsed.FCV_12003 },
      FCV_12004: { ...DEFAULT_VALVES.FCV_12004, ...parsed.FCV_12004 },
      FCV_12005: { ...DEFAULT_VALVES.FCV_12005, ...parsed.FCV_12005 },
      FCV_12006: { ...DEFAULT_VALVES.FCV_12006, ...parsed.FCV_12006 },

    };

  } catch {
    return DEFAULT_VALVES;
  }
});



/* ✅ Persist */
  useEffect(() => {
    localStorage.setItem("Desalter1_valveData", JSON.stringify(valveData));
  }, [valveData]);

  /* ================= ✅ FIXED UPDATE FUNCTION ================= */
  const updateValveData = (tag, field, value) => {
  setValveData(prev => ({
    ...prev,
    [tag]: {
      ...(prev[tag] || DEFAULT_VALVES[tag]),
      [field]: field === "opening" ? Number(value) || 0 : value
    }
  }));
};

  /* ================= PANEL CONTROL ================= */
  const [openPanels, setOpenPanels] = useState([]);

  const openPanel = (tag) => {
    if (!openPanels.includes(tag)) {
      setOpenPanels(prev => [...prev, tag]);
    }
  };

  const closePanel = (tag) => {
    setOpenPanels(prev => prev.filter(p => p !== tag));
  };


  // ================= PUMP PANEL LOGIC =================

  const [openPumpPanels, setOpenPumpPanels] = useState([]);

const openPumpPanel = (tag) => {
  if (!openPumpPanels.includes(tag)) {
    setOpenPumpPanels(prev => [...prev, tag]);
  }
};

const closePumpPanel = (tag) => {
  setOpenPumpPanels(prev => prev.filter(p => p !== tag));
};





const [panelPos, setPanelPos] = useState({ x: 0, y: 80 });
const [dragging, setDragging] = useState(false);
const offsetRef = useRef({ x: 0, y: 0 });

const handleMouseDown = (e) => {
  setDragging(true);

  offsetRef.current = {
    x: e.clientX - panelPos.x,
    y: e.clientY - panelPos.y,
  };
};

const handleMouseMove = (e) => {
  if (!dragging) return;

  setPanelPos({
    x: e.clientX - offsetRef.current.x,
    y: e.clientY - offsetRef.current.y,
  });
};

const handleMouseUp = () => {
  setDragging(false);
};

useEffect(() => {
  window.addEventListener("mousemove", handleMouseMove);
  window.addEventListener("mouseup", handleMouseUp);

  return () => {
    window.removeEventListener("mousemove", handleMouseMove);
    window.removeEventListener("mouseup", handleMouseUp);
  };
}, [dragging]);




const tagStyle = {
      position: "absolute",
      top: -30,
      left: "50%",
      transform: "translateX(-50%)",

      background: "black",
      color: "#00ffcc",

      fontSize: "13px",
      fontWeight: "bold",

      padding: "3px 8px",
      borderRadius: "4px",

      border: "1px solid #555",

      whiteSpace: "nowrap",
      zIndex: 999
    };





  // =============================
  // ELECTRIC GRID STATE
  // =============================
  const [gridState, setGridState] = useState("STOP");
  const [ZI_12001, setZI_12001] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      if (gridState === "START") {
        setZI_12001(prev => {
          if (prev >= 55)
            return 55;
          return Number(
            (prev + 0.3).toFixed(2)
          );
        });
      }
      if (gridState === "STOP") {
        setZI_12001(0);
      }
    }, 500);
    return () => clearInterval(timer);
  }, [gridState]);





// ================= RETREIVING OF DATA FROM OTHER PAGES VIA LOCAL STROAGE =================

           const { transmitters, } = usePlantStore();
            const TT_11007 = transmitters.TT_11007 || 0;
            const FIC_1901 = transmitters.FIC_1901 || 0;
            const FIC_11011 = transmitters.FIC_11011 || 0;
            const FIC_13006a = transmitters.FIC_13006a || 0;
            const FIC_3904 = transmitters.FIC_3904 || 0;



  const xv12001Open = !valves?.XV_12001;
  const xv12002Open = !valves?.XV_12002;
  const xv12003Open = !valves?.XV_12003;
  const xv12004Open = !valves?.XV_12004;
  const xv12005Open = !valves?.XV_12005;



  const FIC_12001 = FIC_1901;
  const TT_12001 = TT_11007;

  const FIC_12002 = 30.354 * (valveData?.FCV_12002?.opening || 0)/100;  // ================= DECALSIFIER
  const FIC_12003 = 60.354 * (valveData?.FCV_12003?.opening || 0)/100;  // ================= DEMULSIFIER
  const FIC_12004 = FIC_3904 * (valveData?.FCV_12001?.opening || 0)/100;   // ================= WASH WATER
  const FIC_12005 = 0.645 * (valveData?.FCV_12004?.opening || 0)/100;   // ================= RINSE WATER
  const FIC_12006 = FIC_13006a * (valveData?.FCV_12005?.opening || 0)/100;   // ================= OIL RETURN
  const FIC_12007 = 4.545 * (valveData?.LCV_12001?.opening || 0)/100;   // ================= BRIME WATER DRAINAGE

  const FIC_12008 = ((FIC_12001) + (FIC_12002/1000/159) + (FIC_12003/1000/159) + (FIC_12004) + (FIC_11011)) * (valveData?.PDV_12001?.opening || 0)/60;
  const FIC_12009 = xv12001Open && (xv12002Open || xv12003Open) ? 40.545 * (valveData?.FCV_12006?.opening || 0)/100 : 0;
  const FIC_12010 = xv12005Open ? 25.43 : 0;
  
  
   /* =========================================================
              SPLITTING OF MAIN BLENDING LINE
========================================================= */

const openV201ALine =
[
  xv12002Open,
  xv12003Open
].filter(Boolean).length;

const FIC_12012 =
  xv12002Open
    ? FIC_12009 / openV201ALine
    : 0;

const FIC_12011 =
  xv12003Open
    ? FIC_12009 / openV201ALine
    : 0;


  const FIC_12013 = (((FIC_12002/1000/159) + (FIC_12003/1000/159) + (FIC_12004)) * (valveData?.PDV_12001?.opening || 0)/100) + FIC_12005;  // ================= WATER AND CHECMICAL INJECTION RATE


const MixValveOpening = (valveData?.PDV_12001?.opening || 0)/100;
    

    


useEffect(() => {

  const current =
    PlantStore.get().transmitters;


  if (
    current.FIC_12011 === FIC_12011 &&
    current.MixValveOpening === MixValveOpening &&
    current.TT_12001 === TT_12001 &&
    current.ZI_12001 === ZI_12001 &&
    current.FIC_12005 === FIC_12005 &&
    current.FIC_12006 === FIC_12006 &&
    current.FIC_12004 === FIC_12004 &&
    current.FIC_12003 === FIC_12003 &&
    current.FIC_12002 === FIC_12002 &&
    current.FIC_12007 === FIC_12007 &&
    current.FIC_12012 === FIC_12012 &&
    current.FIC_12001 === FIC_12001 
  ) {
    return;
  }


  PlantStore.set({
    transmitters: {

      ...current,

      FIC_12011,
      MixValveOpening,
      TT_12001,
      ZI_12001,
      FIC_12005,
      FIC_12006,
      FIC_12004,
      FIC_12003,
      FIC_12002,
      FIC_12001,
      FIC_12007,
      FIC_12012

    }
  });


}, [
  FIC_12011,
  MixValveOpening,
  TT_12001,
  ZI_12001,
  FIC_12005,
  FIC_12006,
  FIC_12004,
  FIC_12003,
  FIC_12002,
  FIC_12001,
  FIC_12007,
  FIC_12012
]);







  return (
    <div className="Desalter1-container">

      {/* TITLE */}
      <h2
        style={{
          position: "absolute",
          top: "0px",
          left: "240px",
          color: "white",
          background: "rgb(30, 5, 250)",
          padding: "2px 273px",
          zIndex: 10,
        }}
      >
        ELECTRIC DESALINATION UNIT (A)
      </h2>


 {/* =================SHUTDOWN VALVES ================= */}


      {/* XV-12001 */}
      <Valve
        className="XV-12001"
        tag="XV_12001"
        x={684}
        y={130}
        isClosed={valves.XV_12001}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-12002 */}
      <Valve
        className="XV-12002"
        tag="XV_12002"
        x={1002}
        y={395}
        isClosed={valves.XV_12002}
        toggle={toggleValve}
        r={90}
      />

      {/* XV-12003 */}
      <Valve
        className="XV-12003"
        tag="XV_12003"
        x={1087}
        y={95}
        isClosed={valves.XV_12003}
        toggle={toggleValve}
      />

      {/* XV-12005 */}
      <Valve
        className="XV-12005"
        tag="XV_12005"
        x={534}
        y={173}
        isClosed={valves.XV_12005}
        toggle={toggleValve}
      />




      {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* PDV-12001 */}
        <div
            style={{ position: "absolute", left: 654, top: 545, transform: "rotate(90deg)", transformOrigin: "center"}}
            onMouseEnter={() => setHoveredValve("PDV_12001")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("PDV_12001")}
          >

            {hoveredValve === "PDV_12001" && (
              <div style={tagStyle}>
                PDV_12001
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="PDV-12001">
                    
          <defs>
            <linearGradient id="metal_12001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_12001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_12001)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      

      {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* LCV-12001 */}
        <div
            style={{ position: "absolute", left: 1045, top: 579,}}
            onMouseEnter={() => setHoveredValve("LCV_12001")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("LCV_12001")}
          >

            {hoveredValve === "LCV_12001" && (
              <div style={tagStyle}>
                LCV_12001
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="LCV-12001">
                    
          <defs>
            <linearGradient id="metal_12001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_12001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_12001)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
      {/* ================= CONTROL VALVES SVG ================= */}
        

         {/* FCV-12001 */}
        <div
            style={{ position: "absolute", left: 445, top: 586,}}
            onMouseEnter={() => setHoveredValve("FCV_12001")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_12001")}
          >

            {hoveredValve === "FCV_12001" && (
              <div style={tagStyle}>
                FCV_12001
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-12001">
                    
          <defs>
            <linearGradient id="metal_12001">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_12001)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_12001)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
         {/* FCV-12002 */}
        <div
            style={{ position: "absolute", left: 267, top: 768,}}
            onMouseEnter={() => setHoveredValve("FCV_12002")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_12002")}
          >

            {hoveredValve === "FCV_12002" && (
              <div style={tagStyle}>
                FCV_12002
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-12002">
                    
          <defs>
            <linearGradient id="metal_12002">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_12002)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_12002)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
         {/* FCV-12003 */}
        <div
            style={{ position: "absolute", left: 297, top: 645,}}
            onMouseEnter={() => setHoveredValve("FCV_12003")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_12003")}
          >

            {hoveredValve === "FCV_12003" && (
              <div style={tagStyle}>
                FCV_12003
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-12003">
                    
          <defs>
            <linearGradient id="metal_12003">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_12003)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_12003)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
         
         
         {/* FCV-12004 */}
        <div
            style={{ position: "absolute", left: 297, top: 524,}}
            onMouseEnter={() => setHoveredValve("FCV_12004")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_12004")}
          >

            {hoveredValve === "FCV_12004" && (
              <div style={tagStyle}>
                FCV_12004
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-12004">
                    
          <defs>
            <linearGradient id="metal_12004">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_12004)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_12004)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      
         {/* FCV-12005 */}
        <div
            style={{ position: "absolute", left: 297, top: 453,}}
            onMouseEnter={() => setHoveredValve("FCV_12005")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_12005")}
          >

            {hoveredValve === "FCV_12005" && (
              <div style={tagStyle}>
                FCV_12005
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-12005">
                    
          <defs>
            <linearGradient id="metal_12005">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_12005)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_12005)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>


 {/* FCV-13006 */}
        <div
            style={{ position: "absolute", left: 787, top: 88,}}
            onMouseEnter={() => setHoveredValve("FCV_12006")}
            onMouseLeave={() => setHoveredValve(null)}
            onClick={() => openPanel("FCV_12006")}
          >

            {hoveredValve === "FCV_12006" && (
              <div style={tagStyle}>
                FCV_12006
              </div>
            )}

            <svg width="80" height="50" viewBox="0 0 200 220" className="FCV-12006">
                    
          <defs>
            <linearGradient id="metal_12006">
              <stop offset="0%" stopColor="#bdc3c7" />
              <stop offset="50%" stopColor="#ecf0f1" />
              <stop offset="100%" stopColor="#7f8c8d" />
            </linearGradient>
          </defs>


          <path d="M20 60 A80 60 0 0 1 180 60 L180 90 L20 90 Z"
            fill="#eb2a11" stroke="#3498db" strokeWidth="2" />

          <rect x="95" y="90" width="10" height="70" fill="#3d5f2a" />

          <polygon points="20,200 100,150 20,110"
            fill="url(#metal_12006)" stroke="#7f8c8d" strokeWidth="2" />

          <polygon points="180,200 100,150 180,110"
            fill="url(#metal_12006)" stroke="#7f8c8d" strokeWidth="2" />

        </svg>
      </div>
      

      



     
       

        
        {/* ================= CONTROL VALVE FACEPLATES ================= */}
          {openPanels.map((tag, index) => (
            <ControlValveControlPanel
              key={tag}
              tag={tag}
              data={valveData?.[tag] ?? DEFAULT_VALVES?.[tag]}
              update={updateValveData}
              close={() => closePanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}

           {/* ================= PUMPS CONTROL VALVE FACEPLATES ================= */}
          {openPumpPanels.map((tag, index) => (
            <PumpFaceplate
              key={tag}
              tag={tag}
              close={() => closePumpPanel(tag)}
              defaultPosition={{
                x: 300 + index * 40,
                y: 150 + index * 40
              }}
            />
          ))}


          
                    {/* ================= MDS FACEPLATE ================= */}
          
                    {showMDS && (
                      <Analyzer1Faceplate
                        close={() => setShowMDS(false)}
                        showBargeSelector={false}
                      />
                    )}


              {/* ================= CRUDE V-201A OUTLET FACEPLATE ================= */}
                    {showAnalyzerV201A && (
                      <AnalyzerV201AFaceplate
                        close={() =>
                          setShowAnalyzerV201A(false)
                        }
                      />
                    )
                  }
          



    {/* ================= CONTROL VALVE OUTPUTS ================= */}


      <ValveOutput
        value={Number(valveData?.PDV_12001?.opening || 0)}
        x={638}
        y={565}
      />

      <ValveOutput
        value={Number(valveData?.LCV_12001?.opening || 0)}
        x={1067}
        y={623}
      />

      <ValveOutput
        value={Number(valveData?.FCV_12001?.opening || 0)}
        x={467}
        y={629}
      />

      <ValveOutput
        value={Number(valveData?.FCV_12002?.opening || 0)}
        x={287}
        y={809}
      />

      <ValveOutput
        value={Number(valveData?.FCV_12003?.opening || 0)}
        x={317}
        y={689}
      />

      <ValveOutput
        value={Number(valveData?.FCV_12004?.opening || 0)}
        x={317}
        y={569}
      />

      <ValveOutput
        value={Number(valveData?.FCV_12005?.opening || 0)}
        x={317}
        y={499}
      />

      <ValveOutput
        value={Number(valveData?.FCV_12006?.opening || 0)}
        x={808}
        y={133}
      />


      
        <button
          onClick={() => setShowMDS(true)}
          style={{
            position: "absolute",
            top: "745px",
            left: "550px",
            padding: "5px 2px",
            background: "#ff9800",
            color: "#000",
            border: "none",
            borderRadius: "4px",
            fontWeight: "bold",
            cursor: "pointer",
            zIndex: 500
          }}
        >
          Crude Analyzer
        </button>


        <button
          className="control-btn"

          style={{
            position: "absolute",
            left: "1010px",
            top: "170px",
            zIndex: 500
          }}

          onClick={() =>
            setShowAnalyzerV201A(true)
          }
        >
          V-201A Analyzer
        </button>




        <ElectricGridButton
          state={gridState}
          setState={setGridState}
          stopGrid={()=>setZI_12001(0)}
          x={787}
          y={218}
        />


        <ElectricGrid
          state={gridState}
          x={450}
          y={240}
          width={650}
          height={140}
          />






        <Transmitter
          tag="TT_12001"
          value={[TT_12001]}
          x={222}
          y={697}
          unit="°C"
          max={200}
          HH={186}
          H={165}
          L={0}
          LL={0}
          c="lime"
          description="TEMPERATURE OF CRUDE FROM E-104A/B TO INLET OF DIFFERENTIAL PRESSURE CONTROLLED MIXING VALVE SUCTION OF V-201A"
         />

         <Transmitter
          tag="FIC_12001"
          value={[FIC_12001]}
          x={135}
          y={697}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PRODUCTION CRUDE FROM PRE-HEAT TRAIN 1 HEAT EXCHANGER (E-101A/B TO E-104A/B) TO INLET OF DIFFERENTIAL PRESSURE CONTROLLED MIXING VALVE SUCTION OF V-201A"
         />

         <Transmitter
          tag="FIC_12002"
          value={[FIC_12002]}
          x={385}
          y={797}
          unit="mL/M"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF DECALCIFIER FROM DECALCIFIER UNIT TO DIFFERENTIAL PRESSURE CONTROLLED MIXING VALVE SUCTION OF V-201A"
         />

         <Transmitter
          tag="FIC_12003"
          value={[FIC_12003]}
          x={185}
          y={634}
          unit="mL/M"
          max={100}
          HH={80}
          H={70}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF DEMULSIFIER FROM DEMULSIFIER UNIT TO DIFFERENTIAL PRESSURE CONTROLLED MIXING VALVE SUCTION OF V-201A"
         />

         <Transmitter
          tag="FIC_12004"
          value={[FIC_12004]}
          x={185}
          y={576}
          unit="BPM"
          max={2.5}
          HH={2}
          H={1.8}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF PRIMARY WASH WATER FROM WATER SUPPLY PUMPS TO DIFFERENTIAL PRESSURE CONTROLLED MIXING VALVE SUCTION OF V-201A"
         />

         <Transmitter
          tag="FIC_12005"
          value={[FIC_12005]}
          x={185}
          y={516}
          unit="BPM"
          max={1.5}
          HH={1.1}
          H={0.6}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF RINSE WATER FROM WATER SUPPLY PUMPS TO  V-201A"
         />

         <Transmitter
          tag="FIC_12006"
          value={[FIC_12006]}
          x={185}
          y={446}
          unit="BPM"
          max={35}
          HH={34}
          H={30}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF OIL RETURN FROM V-201A TO V-201B OIL RETURN PUMPS"
         />

         <Transmitter
          tag="FIC_12007"
          value={[FIC_12007]}
          x={885}
          y={569}
          unit="BPM"
          max={5}
          HH={3}
          H={2}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF BRIME WATER DRAINAGE FROM V-201A TO E-201A/B"
         />

         <Transmitter
          tag="FIC_12008"
          value={[FIC_12008]}
          x={685}
          y={489}
          unit="BPM"
          max={5}
          HH={3}
          H={2}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF MIXED SOLUTION OF CRUDE, WASH WATER, DEMULSIFIER AND DECALCIFIER FROM PDV (DIFFERENTIAL PRESSURE MIXING VALVE) TO V-201A"
         />

         <Transmitter
          tag="FIC_12009"
          value={[FIC_12009]}
          x={885}
          y={129}
          unit="BPM"
          max={5}
          HH={3}
          H={2}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF MIXED SOLUTION OF DEHYDRATED CRUDE FROM V-201A TO V-201B"
         />


         <Transmitter
          tag="FIC_12010"
          value={[FIC_12010]}
          x={385}
          y={139}
          unit="BPM"
          max={35}
          HH={30}
          H={25}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF RELIEVED MIXED SOLUTION OF PRESSURIZED DEHYDRATED CRUDE FROM V-201A TO OIL RETURN PUMPS TO SLOP TANK"
         />

         <Transmitter
          tag="FIC_12011"
          value={[FIC_12011]}
          x={1125}
          y={129}
          unit="BPM"
          max={35}
          HH={30}
          H={25}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF MIXED SOLUTION OF DEHYDRATED CRUDE FROM V-201A AFTER SAMPLING POINT TO V-201B"
         />

         <Transmitter
          tag="FIC_12012"
          value={[FIC_12012]}
          x={1025}
          y={329}
          unit="BPM"
          max={35}
          HH={30}
          H={25}
          L={0}
          LL={0}
          c="lime"
          description="FLOWRATE OF UNQUALIED CRUDE FROM V-201A TO SLOP TANK"
         />

         <Transmitter
          tag="ZI_12001"
          value={[ZI_12001]}
          x={785}
          y={179}
          unit="kV"
          max={35}
          HH={30}
          H={25}
          L={0}
          LL={0}
          c="lime"
          description="VOLTAGE OF ELECTRIC CURRENT AT THE ELECTRIC GRID OF V-201A"
         />



    <LevelTransmitterIndicator
      tag="LT-201"
      totalLevel={523}
      inflows={[FIC_12008]}
      outflows={[FIC_12009+FIC_12006+FIC_12010]}
      responseFactor={0.05}
      columnX={466}
      columnY={244}
      columnWidth={396}
      columnHeight={126}
      textX={330}
      textY={260}
      showFlow={true}
      backgroundOpacity={0.01}
      liquidOpacity={0.7}
      service="crude"
    />

    <LevelTransmitterIndicator
      tag="LT-202"
      totalLevel={523}
      inflows={[FIC_12013]}
      outflows={[FIC_12007]}
      responseFactor={0.05}
      columnX={466}
      columnY={244}
      columnWidth={388}
      columnHeight={123}
      textX={902}
      textY={260}
      showFlow={true}
      backgroundOpacity={0.00}
      liquidOpacity={0.3}
      service="water"
    />












    </div>
  );
}

export default Desalter1;